export const GROUPS = Object.freeze({
  CASHIER: "cashier",
  MANAGER: "manager",
  WAREHOUSE_WORKER: "warehouse_worker",
  DIRECTOR: "director",
  DIRECTOR_ASSISTANT: "director_assistant",
  REVISION_WORKER: "revision_worker",
});

/** Кто имеет доступ к разделу «Ревизия». */
export const REVISION_GROUPS = Object.freeze([
  GROUPS.DIRECTOR,
  GROUPS.DIRECTOR_ASSISTANT,
  GROUPS.WAREHOUSE_WORKER,
  GROUPS.REVISION_WORKER,
]);

function norm(g) {
  return String(g).trim().toLowerCase();
}

/** Match API group names case-insensitively (Django may use "Cashier", etc.). */
export function hasGroup(user, group) {
  const groups = user?.groups;
  if (!Array.isArray(groups)) return false;
  const want = norm(group);
  return groups.some((g) => norm(g) === want);
}

export function hasAnyGroup(user, groups) {
  if (!Array.isArray(groups) || groups.length === 0) return false;
  return groups.some((g) => hasGroup(user, g));
}

/**
 * Право из матрицы ролей (`/api/auth/me/` → `permissions: {раздел: [действия]}`).
 *
 * Разделы и действия — `access/registry.py` на бэкенде. Суперпользователь может всё.
 * Любое действие подразумевает просмотр, поэтому по умолчанию проверяется `read`.
 */
export function can(user, resource, action = "read") {
  if (!user) return false;
  if (user.is_superuser) return true;
  const actions = user.permissions?.[resource];
  return Array.isArray(actions) && actions.includes(action);
}
